/**
 * Deep equality comparison that ignores property order
 * @param obj1 First object to compare
 * @param obj2 Second object to compare
 * @returns true if objects are deeply equal
 */
export const deepEqual = (obj1: any, obj2: any): boolean => {
  // Same reference
  if (obj1 === obj2) return true

  // One is null/undefined
  if (obj1 == null || obj2 == null) return obj1 === obj2

  // Different types
  if (typeof obj1 !== typeof obj2) return false

  // Primitives
  if (typeof obj1 !== 'object') return obj1 === obj2

  // Arrays
  if (Array.isArray(obj1)) {
    if (!Array.isArray(obj2)) return false
    if (obj1.length !== obj2.length) return false
    return obj1.every((item, index) => deepEqual(item, obj2[index]))
  }

  if (Array.isArray(obj2)) return false

  // Objects
  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)

  if (keys1.length !== keys2.length) return false

  return keys1.every(key => {
    return Object.prototype.hasOwnProperty.call(obj2, key) && deepEqual(obj1[key], obj2[key])
  })
}

export default deepEqual
